import { z } from "zod";
import type { SourceStatus } from "../../../../lib/corpusApi";
import { commaSeparated } from "../../../../lib/url_filters";
import { TAXONOMY_URN_PATTERN, type TaxonomyUrn } from "@shared/types/taxonomy.ts";

/** The statuses the Documents list can be narrowed to; revoked documents have left the corpus. */
export const DOCUMENT_STATUS_FILTERS = [
  "all",
  "pending",
  "ready",
  "ingested",
] as const satisfies readonly ("all" | SourceStatus)[];

/** What narrows the Documents list. It lives in the URL, so a link opens the same view. */
export const documentListFiltersSchema = z.object({
  status: z.enum(DOCUMENT_STATUS_FILTERS).default("all"),
  /** Health field URNs: documents tagged with any of them. */
  fields: commaSeparated(
    z.custom<TaxonomyUrn>((value) => typeof value === "string" && TAXONOMY_URN_PATTERN.test(value))
  ).default([]),
  /** The corpus feed whose documents to show. */
  feedId: z.string().min(1).nullable().default(null),
  /** A subject (`mesh:<descriptor UI>`): documents that have it among their main subjects. */
  subject: z
    .string()
    .regex(/^mesh:D\d+$/)
    .nullable()
    .default(null),
});

export type DocumentListFilters = z.output<typeof documentListFiltersSchema>;
export type DocumentStatusFilter = DocumentListFilters["status"];
